<template>
  <div class="main-tracker">
    <div class="dashboard-widget-tabs">
      <img src="/static/images/icons/submission_icon_blue.svg" class="submission-icons" />
      <span>Activity Tracker</span>
    </div>
    <div
      class="dashboard-widget-bodies"
      :class="{ 'fix-height': isCombo, 'single-height': !isCombo }"
    >
      <div
        class="dashboard-widget-body"
        data-tab="tracker"
        data-widget="2"
        v-for="(items, index) in data"
        :key="index"
      >
        <h3>{{ index | capitalize }}</h3>
        <div v-if="items.length == 0 && index == 'today'">
          <div class="empty-data">There has been no activity today.</div>
        </div>
        <div v-if="items.length == 0 && index == 'yesterday'">
          <div class="empty-data">There has been no activity yesterday.</div>
        </div>
        <div class="dashboard-widget-due-date" v-for="item in items" :key="item.projectId">
          <div class="col-xs-11" :class="{ 'pl-0': isCombo, 'pl-25': !isCombo }">
            <div class="display-inline" v-if="item.type === 'ADDED_COMMENT'">
              <div class="widget-icon">
                <i class="fa fa-comment-o"></i>
                <span class="badge">{{ item.count }}</span>
              </div>
              <a class="cursor-pointer" @click="redirect(item.nextUrl)"
                >{{ item.title }} has new comments</a
              >
            </div>
            <div class="display-inline" v-if="item.type === 'EXPORT_QUEUED'">
              <div class="widget-icon">
                <img src="/static/images/icons/export.svg" class="calender-icon" />
              </div>
              <a class="cursor-pointer" @click="redirect(item.nextUrl)"
                >{{ item.title }} has been exported</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['sbData', 'isCombo'],
  data() {
    return {
      data: {}
    };
  },
  created() {
    this.accessData();
  },
  methods: {
    async accessData() {
      const x = this.sbData;
      this.data = x.actions;
      if (this.data.today && this.data.today.length > 1) {
        this.data.today.splice(1);
      }
      if (this.data.yesterday && this.data.yesterday.length > 1) {
        this.data.yesterday.splice(1);
      }
    },
    redirect(url) {
      this.$router.push(`/layout/submission-builder?nextUrl=${url}`);
    }
  },
  filters: {
    capitalize(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style scoped>
.submission-icons {
  width: 32px;
  height: 32px;
  margin-top: -3px;
}
.dashboard-widget-tabs {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #0b3c61;
  padding-left: 22px;
  padding-top: 24px;
}
.dashboard-widget-tabs span {
  padding-left: 16px;
}
.empty-data {
  padding-left: 22px;
}
.fix-height {
  max-height: 210px;
}
.single-height {
  max-height: 182px;
}
.widget-card {
  padding: 12px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.dashboard-widget-bodies {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}

.dashboard-widget-body h3 {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
  padding-left: 22px;
}
.dashboard-widget-body .dashboard-widget-due-date {
  display: flex;
  align-items: center;
  margin-top: 0px;
  margin-bottom: 5px;
}
.activity-export-icon {
  margin-right: 20px;
}
.dashboard-widget-due-date a,
.dashboard-widget-due-date .empty-data {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  padding-left: 17px;
  padding-right: 5px;
}
.dashboard-widget-body:last-child {
  padding-bottom: 10px;
}
.pl-5 {
  padding-left: 5px;
}
.pl-20 {
  padding-left: 20px;
}
.dashboard-widget .dashboard-widget-tabs {
  height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.7);
}
.pl-30 {
  padding-left: 30px;
}
.comments-notification {
  margin-left: -11px;
  margin-top: -20px;
}
.mdr-coronary {
  padding-left: 15px;
}
.builder-coronary {
  padding-left: 33px;
}
.d-flex {
  display: flex;
}
.comment-count-wrapper {
  position: relative;
  margin-right: 10px;
  min-width: 34px;
}
.badge {
  background-color: #b00505;
  color: #fff;
  position: absolute;
  top: -5px;
  left: 35px;
}
.widget-icon {
  margin-top: -2px;
}
.fa-comment-o {
  font-size: 24px;
}
.widget-icon img {
  width: 24px;
  height: 24px;
}
.pl-25 {
  padding-left: 25px;
}
.display-inline {
  display: inline-flex;
}
</style>
